






































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Smokeleaf from "../../../store/entities/smokeleaf";
class PagefactoryRequest{
  cId:Number;
  ftId:Number;
  wId:Number;
  fId:Number;
  sId:Number;
}
@Component
export default class EditSmokeleaf extends AbpBase {
  pagefactoryrequest: PagefactoryRequest = new PagefactoryRequest();
  @Prop({ type: Boolean, default: false }) value: boolean;
  created() {}
  smokeleaf: Smokeleaf = new Smokeleaf();
  save() {
    (this.$refs.smokeleafForm as any).validate(async (valid: boolean) => {
      if (valid) {
        if(this.smokeleaf["comeTime"] == ""){
          this.smokeleaf["comeTime"] = "0001/1/1 0:00:00";
        }
        if(this.smokeleaf["outTime"] == ""){
          this.smokeleaf["outTime"] = "0001/1/1 0:00:00";
        }
         if(this.smokeleaf["allamount"] == null){
          this.smokeleaf["allamount"] = 0;
        }
        if(this.smokeleaf["weight"] == null){
          this.smokeleaf["weight"] = 0;
        }
        if(this.smokeleaf["samount"] == null){
          this.smokeleaf["samount"] = 0;
        }
        await this.$store.dispatch({
          type: "smokeleaf/update",
          data: this.smokeleaf,
        });
        (this.$refs.smokeleafForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  get factory(){
    return this.$store.state.factory.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.filterlist;
  }
   get floor() {
    return this.$store.state.floor.filterlist;
  }
    get smokecrib() {
    return this.$store.state.smokecrib.filterlist;
  }
  get threshold(){
    return this.$store.state.threshold.list;
  }
  cancel() {
    (this.$refs.smokeleafForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.smokeleaf = Util.extend(true, {}, this.$store.state.smokeleaf.editSmokeleaf);
      //console.log(this.smokeleaf);
      this.selfactory(this.smokeleaf.ftId);
      this.selwarehouse(this.smokeleaf.wId);
      this.selfloor(this.smokeleaf.fId);
    }
  }
   smokeleafRule = {
      ftId: [{type:"number",required: true, message: "请选择库区", trigger: "change" }],
    wId: [{type:"number",required: true, message: "请选择库房", trigger: "change" }],
    //sId: [{ type:"number",required: true, message: "请选择烟垛", trigger: "change" }],
    fId: [{type:"number",required: true, message: "请选择楼层", trigger: "change" }],
  };
  selfactory(value:Number){
    this.pagefactoryrequest.ftId = value;
    this.getwarehouse();
      this.getfloor();
      this.getsmokecrib();
  }
  selwarehouse(value:Number){
    this.pagefactoryrequest.wId = value;
    this.getfloor();
  }
  selfloor(value:Number){
    this.pagefactoryrequest.fId = value;
      this.getsmokecrib();
  }
  async getsmokecrib() {
    //烟叶
    //filters
    await this.$store.dispatch({
      type: "smokecrib/getfilter",
       data: this.pagefactoryrequest,
    });
  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getfilter",
      data: this.pagefactoryrequest,
    });
  }
  async getfloor() {
    //楼层
    //filters
    await this.$store.dispatch({
      type: "floor/getfilter",
      data: this.pagefactoryrequest,
    });
  }
}
